import React from 'react';
import { useLocation } from 'react-router-dom';

export default function ComingSoon() {
  const location = useLocation();
  const rawPath = location.pathname.substring(1);
  const moduleName = rawPath 
    ? rawPath.split(/[-/]/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
    : "Module";

  return (
    <>
      <style>{`
        @keyframes loading-bar {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        .cs-loader-bar {
          animation: loading-bar 2s infinite linear;
        }
      `}</style>
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.icon}>✨</div>
          <h1 style={styles.title}>{moduleName}</h1>
          <div style={styles.badge}>Coming Soon</div>
          <p style={styles.subtitle}>
            Our engineers are currently building this specialized module for your workspace. 
            Stay tuned for high-performance updates!
          </p>
          <div style={styles.loader}>
            <div className="cs-loader-bar" style={styles.bar}></div>
          </div>
          <button style={styles.btn} onClick={() => window.history.back()}>Go Back</button>
        </div>
      </div>
    </>
  );
}

const styles = {
  container: { 
    height: '100%', 
    minHeight: '80vh',
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    padding: '20px'
  },
  content: { 
    textAlign: 'center', 
    maxWidth: '450px', 
    padding: '50px 40px', 
    background: '#fff', 
    borderRadius: '32px', 
    boxShadow: '0 20px 50px rgba(0,0,0,0.05)',
    border: '1px solid #f1f5f9'
  },
  icon: { 
    fontSize: '60px', 
    marginBottom: '20px',
    filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.1))'
  },
  title: { 
    fontSize: '28px', 
    fontWeight: '800', 
    color: '#0f172a', 
    marginBottom: '8px',
    letterSpacing: '-0.02em'
  },
  badge: {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#eff6ff',
    color: '#2563eb',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '600',
    marginBottom: '24px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  subtitle: { 
    fontSize: '16px', 
    color: '#475569', 
    lineHeight: '1.6', 
    marginBottom: '32px' 
  },
  loader: { 
    height: '4px', 
    width: '120px', 
    background: '#f1f5f9', 
    borderRadius: '100px', 
    margin: '0 auto 32px',
    overflow: 'hidden',
    position: 'relative'
  },
  bar: { 
    height: '100%', 
    width: '40px', 
    background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)', 
    borderRadius: '100px',
    position: 'absolute',
    left: 0
  },
  btn: {
    padding: '12px 24px',
    background: '#0f172a',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  }
};
